jQuery(document).ready(function ($) {
	
	$('.liquid').imgLiquid();
	
	$('.header-lang').on('click', function (e) {
		const $list = $('.header-lang-list');
		
		if ($list.hasClass('open-lang-list')) {
			$list.removeClass('open-lang-list');
		} else {
			$list.addClass('open-lang-list');
		}
	});
	
	$('.list-h-title').click(function () {
		$(this).next().animate({height: ['toggle', 'swing'],});
		$(this).toggleClass("open");
	});
	
	setTimeout(function () {
		$('.page-loader').fadeOut();
	}, 250);
	
	if ($(".referenties-slider").length > 0) {
		
		$(".referenties-slider").slick({
			dots: true,
			arrows: true,
			slidesToShow: 2,
			slidesToScroll: 1,
			swipe: false,
			responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
					arrows: false
				}
			}]
		});
		
	}
	
	if ($(".search-c-text").length > 0) {
		
		$(".search-c-text").slick({
			dots: false,
			arrows: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 3000,
			responsive: [{
				breakpoint: 992,
				settings: {
					centerMode: false,
					slidesToShow: 2,
					arrows: false
				}
			}, {
				breakpoint: 768,
				settings: {
					centerMode: false,
					slidesToShow: 1,
					arrows: false
				}
			},]
		});
		
	}
	
	if ($('.slider-speakers').length > 0) {
		
		$('.slider-speakers').slick({
			dots: true,
			arrows: true,
			slidesToShow: 5,
			slidesToScroll: 5,
			autoplay: true,
			autoplaySpeed: 4000,
			responsive: [{
				breakpoint: 1420,
				settings: {
					arrows: false
				}
			}, {
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
					arrows: false
				}
			}, {
				breakpoint: 890,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					arrows: false,
					dots: false
				}
			}, {
				breakpoint: 648,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					arrows: false,
					dots: false
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					arrows: false,
					dots: false
				}
			}, {
				breakpoint: 350,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 2,
					arrows: false,
					dots: false
				}
			}]
		});
		
	}
	
	if ($('.header-slider').length > 0) {
		
		$('.header-slider').slick({
			dots: false,
			arrows: true,
			fade: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000
		});
		
	}
	
	if ($('.slider-nieuws').length > 0) {
		
		$('.slider-nieuws').slick({
			dots: true,
			arrows: true,
			centerMode: true,
			centerPadding: '0px',
			slidesToShow: 3,
			slidesToScroll: 1,
			responsive: [{
				breakpoint: 992,
				settings: {
					centerMode: false,
					slidesToShow: 2,
					arrows: false
				}
			}, {
				breakpoint: 768,
				settings: {
					centerMode: false,
					slidesToShow: 1,
					arrows: false
				}
			},]
		});
		
	}
	
	if ($('.slider-magazines').length > 0) {
		
		$('.slider-magazines').slick({
			dots: true,
			arrows: true,
			centerMode: true,
			centerPadding: '0px',
			slidesToShow: 5,
			slidesToScroll: 1,
			responsive: [{
				breakpoint: 1440,
				settings: {
					slidesToShow: 3,
					arrows: false
				}
			}, {
				breakpoint: 992,
				settings: {
					centerMode: false,
					slidesToShow: 2,
					arrows: false
				}
			}, {
				breakpoint: 768,
				settings: {
					centerMode: false,
					slidesToShow: 1,
					arrows: false
				}
			},]
		});
		
	}
	
	if ($('.slider-videos').length > 0) {
		
		$('.slider-videos').slick({
			dots: true,
			arrows: false,
			slidesToShow: 2,
			slidesToScroll: 1,
			responsive: [{
				breakpoint: 660,
				settings: {
					centerMode: false,
					slidesToShow: 1,
					arrows: false
				}
			}]
		});
		
	}
	
	jQuery.fn.lightTabs = function (options) {
		
		var createTabs = function () {
			tabs = this;
			i = 0;
			// console.log(this);
			showPage = function (tabs, i) {
				$(tabs).children("div").children("div").hide();
				$(tabs).children("div").children("div").eq(i).show();
				$(tabs).children("ul").children("li").removeClass("active");
				$(tabs).children("ul").children("li").eq(i).addClass("active");
			}
			
			showPage(tabs, 0);
			
			$(tabs).children("ul").children("li").each(function (index, element) {
				$(element).attr("data-page", i);
				i++;
			});
			
			$(tabs).children("ul").children("li").click(function () {
				showPage($(this).parent().parent(), parseInt($(this).attr("data-page")));
			});
		};
		return this.each(createTabs);
	};
	
	if (jQuery('#page2_button').length) {
		jQuery('#page2_button').click(function (e) {
			e.preventDefault();
			
			jQuery(".validate_quote_p1").validate();
			var valid = jQuery(".validate_quote_p1").valid();
			
			if (valid) {
				
				jQuery(".validate_quote_p1 input").each(function () {
					var name = jQuery(this).attr("name");
					if (jQuery("form.validate_quote input[name=\"" + name + "\"").length) {
						jQuery("form.validate_quote input[name=\"" + name + "\"").val(jQuery(this).val());
					}
				});
				
				
				jQuery("#page_1").hide();
				jQuery("#page_2").show('slow');
				
				jQuery([document.documentElement, document.body]).animate({
					scrollTop: jQuery("#page_2").offset().top - 120
				}, 1000);
			}
			return false;
		});
	}
	
	$(document).on('click', '.pushy ul.main li.menu-item-has-children a', function (e) {
		e.preventDefault();
		var link = $(this).attr('href');
		
		if ($(this).parent().hasClass('open')) {
			window.location.href = link;
			
		} else {
			$(this).parent().addClass('open');
		}
	});
	
	$('.validate_quote select[name="learn"]').change(function () {
		var value = $(this).val();
		
		if (value == 'Other') {
			$('.validate_quote input[name="learn-other"]').show();
		} else {
			$('.validate_quote input[name="learn-other"]').hide();
		}
	});
	
	$(".container-scroll-btn ul li").on("click", "a", function (event) {
		event.preventDefault();
		var id = $(this).attr('href'),
			top = $(id).offset().top;
		$('body,html').animate({scrollTop: top - 150}, 1500);
		return false;
	});
	
	if (jQuery('#page1_button').length) {
		jQuery('#page1_button').click(function (e) {
			e.preventDefault();
			
			jQuery("#page_2").hide();
			jQuery("#page_1").show('slow');
			
			jQuery([document.documentElement, document.body]).animate({
				scrollTop: jQuery("#page_1").offset().top - 120
			}, 1000);
			
			return false;
		});
	}
	
	checkMobileStickyButtonVisibility();
	
	$(window).resize(function () {
		checkMobileStickyButtonVisibility();
	});
	
	function checkMobileStickyButtonVisibility() {
		if ($('.mobile-sticky-button').length) {
			if (window.innerWidth <= 991) {
				if (!!window.Intercom) {
					Intercom('shutdown');
				}
				setTimeout(function () {
					$('.mobile-sticky-button').show();
				}, 5000);
			} else {
				$('.mobile-sticky-button').hide();
			}
		}
	}
	
	$('.mobile-filter-btn').click(function () {
		$('.mobile-filter').animate({height: ['toggle', 'swing'],});
		return false;
	});
	
	$(document).on('click', '.youtube-video', function () {
		var embed = $(this).attr('data-video');
		var title = $(this).attr('data-title');
		console.log(embed);
		$('.box-modal-youtube').arcticmodal();
		$('.box-modal-youtube h3').html(title);
		
		if ($(this).hasClass('vimeo-video')) {
			// if its a Vimeo video
			$('.box-modal-youtube #video-embed').html('<iframe width="560" height="315" src="https://player.vimeo.com/video/' + embed + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
		} else {
			// No vimeo video, should be youtube
			$('.box-modal-youtube #video-embed').html('<iframe width="560" height="315" src="https://www.youtube.com/embed/' + embed + '?autoplay=1&rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
		}
	});
	
	$(document).on('click', '.speaker-reference', function () {
		var id = $(this).attr('data-id');
		$('.speaker-reference_modal[data-id="' + id + '"] .box-modal-reference').arcticmodal();
		return false;
	});
	
	$('.geselecteerde-sprekers-open').click(function () {
		$('.box-modal-geselecteerde-sprekers').arcticmodal();
		return false;
	});
	
	$('.box-modal-close').click(function () {
		$.arcticmodal('close');
		$('.box-modal-youtube h3').html('');
		$('.box-modal-youtube #video-embed').html('');
		
		return false;
	});
	
	var windload = $(window).width();
	if (windload <= 768) {
		$('.tabs>ul>li').click(function () {
			var destination = $('#tabs-content-body').offset().top;
			$('html,body').animate({scrollTop: destination - 120}, 800);
			return false;
		});
	} else {
	}
	$(".tabs").lightTabs();
	
	$(".slider-filter>span").on('click', function (event) {
		var parentId = $(this).attr('id');
		
		if ('block0' === $(this).attr('id')) {
			$(".slider-filter>span").removeClass("active");
			$('.slider-speakers').slick('slickUnfilter');
			$('#' + parentId).addClass('active');
		} else {
			$('.slider-speakers').slick('slickUnfilter');
			$(".slider-filter>span").removeClass("active");
			$('.slider-speakers').slick('slickFilter', '.' + $(this).attr('id'));
			$('#' + parentId).addClass('active');
		}
	});
	$('select').niceSelect();
	
	var scroll = 0;
	var header = $('.other-header-page');
	var headerHeight = header.outerHeight();
	var headerSlider = $('.header-slider');
	var headerSliderHeight = headerSlider.outerHeight();
	var headerMagazine = $('.magazine-aanvragen-header');
	var headerMagazineHeight = headerMagazine.outerHeight();
	var headerSpeaker = $('.header-container-spreker');
	var headerSpeakerHeight = headerSpeaker.outerHeight();
	
	$(window).scroll($.throttle(10, function () {
		scroll = $(window).scrollTop();
		
		if (header) {
			header.css({
				"opacity": 1 - scroll / headerHeight,
				"background-position": "center " + scroll / headerHeight * 15 + "%"
			});
		}
		
		if (headerSlider) {
			headerSlider.css({"opacity": 1 - scroll / headerSliderHeight});
		}
		
		if (headerMagazine) {
			headerMagazine.css({
				"opacity": 1 - scroll / headerMagazineHeight,
				"background-position": "center " + scroll / headerMagazineHeight * 15 + "%"
			});
		}
		
		if (headerSpeaker) {
			headerSpeaker.css({
				"opacity": 1 - scroll / headerSpeakerHeight,
				"background-position": "center " + scroll / headerSpeakerHeight * 15 + "%"
			});
		}
		
		if (scroll > 10) {
			$('.header-body, .other-header-body').addClass('scroll-hed');
			$('.logo-site').addClass('logo-s-scroll');
			$('.header-menu-body > ul').addClass('menu-top-scroll');
		} else {
			$('.header-body, .other-header-body').removeClass('scroll-hed');
			$('.logo-site').removeClass('logo-s-scroll');
			$('.header-menu-body > ul').removeClass('menu-top-scroll');
		}
	}));
	
	$.datetimepicker.setLocale('en');
	
	$('#datum-picker, #datum-picker2').datetimepicker({
		timepicker: false,
		format: 'd.m.Y',
		dayOfWeekStart: 1
	});
	
	$('#time-picker, #time-picker2').datetimepicker({
		datepicker: false,
		format: 'H:i'
	});
	
	$('.referenties-short-news').matchHeight();
	$('.referenties-short-news').matchHeight();
	$('.over-ons-team-info').matchHeight();
	$('.icons-part .icon').matchHeight();
	$('.blog-news-short').matchHeight();
	
	$('#quotation-search').submit(function (e) {
		e.preventDefault();
		var search = $(this).find('input').val();
		var exclude = $('#result.add-to-quotation').attr('data-exclude');
		
		$('.add-to-quotation').addClass('load');
		$('#result .person-block-offerte').remove();
		$.post(global.ajax_url, {
			action: "search",
			search: search,
			exclude: exclude,
			nonce: global.nonce
		}, function (response) {
			console.log(response);
			$('.add-to-quotation').removeClass('load');
			if (response.result.count > 0) {
				$(response.result.html).insertAfter('#result .lds-ellipsis');
			}
		});
	});
	
	$(document).on('click', '.person-add-offerte', function () {
		var item = $(this).parent().parent();
		var item_html = item.html();
		var id = $(this).attr('data-id');
		var name = $(this).attr('data-name');
		var cur_ids = $('#result.add-to-quotation').attr('data-exclude');
		var cur_names = $('input[name="speakers_names"]').val();
		
		$('#result.add-to-quotation').attr('data-exclude', cur_ids + ',' + id);
		$('input[name="speakers"]').val(cur_ids + ',' + id);
		$('input[name="speakers_names"]').val(cur_names + ',' + name);
		$('#result .person-block-offerte').remove();
		$('input[name="search"]').val('');
		$('.person-body-offerte').append('<div class="person-block-offerte">' + item_html + '</div>');
	});
	
	$(document).on('click', '.person-del-offerte', function () {
		var item = $(this).parent().parent();
		var id = $(this).attr('data-id');
		var cur_ids = $('#result.add-to-quotation').attr('data-exclude');
		
		item.remove();
		cur_ids = cur_ids.replace(',' + id, '');
		$('input[name="speakers"]').val(cur_ids);
		$('#result.add-to-quotation').attr('data-exclude', cur_ids);
	});
	
	$(".validate_quote").validate();
	
	var flag = false;
	
	$('.btn-quote').click(function (e) {
		e.preventDefault();
		
		var valid = $(".validate_quote").valid();
		
		if (!flag && valid == true) {
			flag = true;
			
			$('.btn-quote span').hide();
			$('.btn-quote .lds-ellipsis').show();
			
			var QuotationData = {};
			$.each($('.validate_quote').serializeArray(), function (i, field) {
				QuotationData[field.name] = field.value;
			});
			
			QuotationData = JSON.stringify(QuotationData);
			
			$.post(global.ajax_url, {
				'action': 'add_quotation',
				'nonce': global.nonce,
				'information': QuotationData,
			}, function (response) {
				var thanks = $('.validate_quote').attr('data-thanks');
				localStorage.setItem('budget', $('input[name="budget"]').val());
				window.location.replace(thanks);
			});
			
			setTimeout(function () {
				flag = false;
				$('.btn-quote span').show();
				$('.btn-quote .lds-ellipsis').hide();
			}, 5000);
		}
	});
	
	$('input[type=radio][name=date_event]').change(function () {
		if ($(this).val() == 'no') {
			$('.date-event').hide();
		} else {
			$('.date-event').show();
		}
	});
	
	$('.icheck-inp-overzitcht input[type="checkbox"]').change(function () {
		if ($(this).prop('checked')) {
			$(this).parent().parent().addClass('active');
		} else {
			$(this).parent().parent().removeClass('active');
		}
	});
	
	$('.overzicht-menu li').click(function () {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
		} else {
			$('.overzicht-menu li').removeClass('active');
			$(this).addClass('active');
		}
	});
	
	$('.close_filter').click(function () {
		$('.overzicht-menu').hide();
	});
	
	$('.mobile-filter-btn').click(function () {
		$('.overzicht-menu').show();
	})
});